import { match } from "path-to-regexp"
import { type RoutePath } from "../core"
import { getQuerylessPath } from "./getQuerylessPath"

/**
 * Create a `path-to-regexp` match function for one or more route paths, ignoring query parameters.
 *
 * @param routePath - Route path or array of route paths to match against
 * @returns A match function that tests a given pathname against the provided route paths
 */
export function matchPath(routePath: RoutePath | RoutePath[]) {
    const routePaths = Array.isArray(routePath) ? routePath : [routePath]
    const paths = routePaths.map((routePath) => getQuerylessPath(routePath.route))

    return match(paths)
}
